__turbopack_context__.v({
  "card": "AppDownloadQrCard-module__JSnj8W__card",
  "label": "AppDownloadQrCard-module__JSnj8W__label",
  "qr": "AppDownloadQrCard-module__JSnj8W__qr",
});
